import { Component, Input } from '@angular/core';
import { Unit } from '../../models/response-unit-data';
import { CommonModule } from '@angular/common';
import { TablePaginationComponent } from 'src/app/pages/common/table-pagination/table-pagination.component';

@Component({
  selector: 'app-response-units-data',
  standalone: true,
  imports: [CommonModule, TablePaginationComponent],
  templateUrl: './response-units-data.component.html'
})
export class ResponseUnitsDataComponent {
  @Input() response: Unit[] = [];

  tableData: Unit[] = [];
  updateRecord(data: Unit[]) {
    setTimeout(() => {
      this.tableData = data;
    }, 0);
  }

}
